import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Redux
import { connect } from 'react-redux';

// Redux Action
import { doRecordListViews } from '../../../actions/recordListViews';
import { withQuery } from '../../../hoc/withGraphql';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ViewCount.css';
import cx from 'classnames';

// Locale
import messages from '../../../locale/messages';


class ViewCount extends Component {

    static propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool,
            GetListViews: PropTypes.shape({
                count: PropTypes.number
            }),
        }),
        listId: PropTypes.number,
        isAuthenticated: PropTypes.bool,
        isHost: PropTypes.bool.isRequired,
        formatMessage: PropTypes.any,
    };

    static defaultProps = {
        data: {
            loading: true,
            GetListViews: {
                count: 0
            }
        },
        listId: null,
        isAuthenticated: false
    };

    componentDidMount() {
        const { listId, doRecordListViews, isAuthenticated, isHost } = this.props;
        if (listId != null && isAuthenticated && !isHost) {
            doRecordListViews(listId);
        }
    }

    render() {
        const { data: { loading, GetListViews } } = this.props;

        if (!loading) {
            return (
                <div>
                    {
                        GetListViews != null && GetListViews.count > 0 && <div className={cx(s.bookItMessage, s.spaceTop3)}>
                            <p className={cx(s.text, s.noMargin)}>
                                <FormattedMessage {...messages.viewCountInfo} />{' '}<FormattedMessage {...messages.viewCountTotal1} /> {GetListViews.count} {GetListViews.count === 1 ? <FormattedMessage {...messages.viewCountSingular} /> : <FormattedMessage {...messages.viewCountTotal2} />}
                            </p>
                        </div>
                    }
                </div>
            );
        } else {
            return (
                <div />
            )
        }
    }
}

const mapState = (state) => ({
    isAuthenticated: state.runtime.isAuthenticated
});

const mapDispatch = {
    doRecordListViews
};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
    withQuery(gql`
        query ($listId:Int!) {
            GetListViews (listId:$listId) {
                count
            }
        }
    `, {
        options: (props) => ({
            variables: {
                listId: props.listId,
            },
            ssr: false
        })
    }),
)(ViewCount);